import { render, staticRenderFns } from "./BLAmend.vue?vue&type=template&id=500a5e44&"
import script from "./BLAmend.vue?vue&type=script&lang=js&"
export * from "./BLAmend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports